import { Exception } from './exception';

export class ParameterException extends Exception {}
